"use client";
import React from "react";
import { News, WaveBgColor } from "../../../global";
import NewsCard from "../news/newsCard";
import BottomCurves from "../curves/bottomCurves";
import FloatingArrow from "../uiDecor/floatingArrow";
import { useRouter } from "next/navigation";

interface RelatedNewsProps {
  data: {
    heading: string;
    news: News[];
    waveBgColor: WaveBgColor;
  };
}

export default function RelatedNews({ data }: RelatedNewsProps) {
  const router = useRouter();
  return (
    <section className="bg-rainbow pb-24 md:pb-[10.333vw] pt-24 md:pt-[6.333vw]">
      <FloatingArrow
        direction={"right"}
        className="top-0 right-[10.625vw]"
        wrapText="discover"
      />
      <div className="flex flex-col items-center">
        {/* <h2 className="text-purple">{data.heading}</h2> */}
        <h2 className="text-purple">Discover More Articles</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {data.news.map((newsItem: any, index: number) => (
            <div
              className="col-span-1"
              key={index}
              onClick={() => {
                router.push(`/news/${newsItem.slug}`);
              }}
            >
              <NewsCard
                title={newsItem.title}
                date={newsItem.date}
                tag={newsItem.tag}
                image={newsItem.image}
              />
            </div>
          ))}
        </div>
      </div>
      <BottomCurves
        color={data.waveBgColor.waveBgColor}
        direction="right"
      />
    </section>
  );
}
